import React from 'react'
import { shallow, mount } from 'enzyme'
import PodCardHeader from '../PodCardHeader'

describe('<PodCardHeader />', () => {
  let wrapper, props, instance
  beforeEach(() => {
    props = {
      onDeleteModalOpen() {},
      onEditClick() {},
      name: 'testing'
    }
    wrapper = shallow(<PodCardHeader {...props} />)
    instance = wrapper.instance()
  })
  describe('#onMenuToggle', () => {
    describe('when isMenuOpen is true', () => {
      beforeEach(() => {
        wrapper.setState({ isMenuOpen: true })
      })
      it('should change isMenuOpen to false', () => {
        instance.onMenuToggle()
        expect(wrapper.state('isMenuOpen')).toBe(false)
      })
      it('should remove an event listener from the document', () => {
        const removeEventListenerMock = jest.fn()
        document.removeEventListener = removeEventListenerMock
        instance.onMenuToggle()
        expect(removeEventListenerMock).toHaveBeenCalledTimes(1)
      })
    })
    describe('when isMenuOpen is false', () => {
      beforeEach(() => {
        wrapper.setState({ isMenuOpen: false })
      })
      it('should change isMenuOpen to true', () => {
        instance.onMenuToggle()
        expect(wrapper.state('isMenuOpen')).toBe(true)
      })
      it('should add an event listener to the document', () => {
        const addEventListenerMock = jest.fn()
        document.addEventListener = addEventListenerMock
        instance.onMenuToggle()
        expect(addEventListenerMock).toHaveBeenCalledTimes(1)
      })
    })
    describe('#onDeleteClick', () => {
      it('should call the onDeleteModalOpen prop', () => {
        const onDeleteModalOpenMock = jest.fn()
        wrapper.setProps({ onDeleteModalOpen: onDeleteModalOpenMock })
        instance.onDeleteClick()
        expect(onDeleteModalOpenMock).toHaveBeenCalledTimes(1)
      })
      it('should call its own onMenuToggle method', () => {
        const onMenuToggleMock = jest.fn()
        instance.onMenuToggle = onMenuToggleMock
        instance.onDeleteClick()
        expect(onMenuToggleMock).toHaveBeenCalledTimes(1)
      })
    })
    describe('#onEditClick', () => {
      it('should call the onEditClick prop', () => {
        const onEditClickMock = jest.fn()
        wrapper.setProps({ onEditClick: onEditClickMock })
        instance.onEditClick()
        expect(onEditClickMock).toHaveBeenCalledTimes(1)
      })
      it('should call its own onMenuToggle method', () => {
        const onMenuToggleMock = jest.fn()
        instance.onMenuToggle = onMenuToggleMock
        instance.onDeleteClick()
        expect(onMenuToggleMock).toHaveBeenCalledTimes(1)
      })
    })
    describe('#onDocumentClick', () => {
      it('should call its own onMenuToggle method', () => {
        const onMenuToggleMock = jest.fn()
        instance.onMenuToggle = onMenuToggleMock
        instance.onDeleteClick()
        expect(onMenuToggleMock).toHaveBeenCalledTimes(1)
      })
    })
    describe('#componentWillUnmount', () => {
      it('should remove the event listener from the document', () => {
        const removeEventListenerMock = jest.fn()
        document.removeEventListener = removeEventListenerMock
        instance.componentWillUnmount()
        expect(removeEventListenerMock).toHaveBeenCalledTimes(1)
      })
    })
    describe('#render', () => {
      it('should render the provided pod name', () => {
        expect(mount(instance.render()).find('PodCardHeader__Title').text()).toBe(props.name)
      })
    })
  })
})
